import { PayloadAction } from '@reduxjs/toolkit';
import {
    call, put, select, takeLeading,
} from 'redux-saga/effects';

import { ApiResponse } from '@commblades/commblades';

import { handleSubmitError, startBladeNavigation } from '../../navigationSlice';
import Blades from '../Blades';
import { submitYourFinance } from '../yourFinance/yourFinanceSlice';
import { YourFinanceResponse, YourFinanceSubmit } from '../yourFinance/yourFinanceTypes';
/* istanbul ignore file */
import { selectYourFinanceSubmitUrl } from '../yourFinance/yourFinanceSelectors';
import submitYourFinanceApi from '../yourFinance/yourFinanceApi';
import { getBorrowingPowerFinanceDataFulfilled } from '../borrowingPower/borrowingPowerSlice';
import { YOUR_FINANCE_BLADE_ID } from '../../types';
import { loadSpinner, unloadSpinner } from '../../../../components/Spinner/spinnerSlice';

function* debtConsolidationSubmitWorkSaga(action: PayloadAction<YourFinanceSubmit>) {
    try {
        if (action.payload.bladeName === YOUR_FINANCE_BLADE_ID.DEBT_CONSOLIDATION) {
            yield put(loadSpinner('Loading...'));
            const url: string = yield select(selectYourFinanceSubmitUrl);

            const yourFinanceResponse: ApiResponse<YourFinanceResponse> = yield call(submitYourFinanceApi, url, action.payload);

            yield put(getBorrowingPowerFinanceDataFulfilled(yourFinanceResponse.data));
            yield put(startBladeNavigation(Blades.DebtConsolidation.next));
            yield put(unloadSpinner());
        }
    } catch (e) {
        yield put(unloadSpinner());
        yield put(handleSubmitError({ errorMessage: `debt consolidation submit rejected - ${(e as Error).message}` }));
    }
}

function* debtConsolidationSubmitWatchSaga() {
    yield takeLeading(submitYourFinance.type, debtConsolidationSubmitWorkSaga);
}

export const debtConsolidationWatchSaga = [
    debtConsolidationSubmitWatchSaga,
];
